import React from "react";
import getAvatarUrl from "../utils/get-avatar-url";
import { useRillContext } from "../rill/RillReact/share/base";

function Avatar({
  className,
  user,
  size = 32,
  url,
  useBgImg,
  overlay,
  height,
  unit,
}) {
  const { locals } = useRillContext();

  user = user || locals.activeUser;
  const { webAppTheme = "dark" } = locals.activeUser;

  const style = useBgImg
    ? {
        backgroundImage: `url(${url})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }
    : {};
  if (overlay) style.position = "relative";
  const avatarURL =
    url && !url.includes("new-icons/user-circle-bg-")
      ? url
      : getAvatarUrl(user, false, webAppTheme);

  return (
    <div className={`avatar ${className}`} style={style}>
      {overlay}
      {!useBgImg && (
        <img
          style={
            !className?.includes("only-show-mobile")
              ? size && className !== "invite-avatar"
                ? {
                    width: size + (unit || "px"),
                    height: (height || size) + (unit || "px"),
                    borderRadius: size + (unit || "px"),
                  }
                : size && className === "invite-avatar"
                ? {
                    top: 0,
                    left: 0,
                    width: size + "px",
                    height: size + "px",
                    borderRadius:
                      (!squareRounded ? size : Math.round(size / 3)) + "px",
                  }
                : {}
              : {}
          }
          className={`${
            url === "/img/avatars/registration-pending2.svg" ? "icon-white" : ""
          }`}
          src={
            url && !url.includes("new-icons/user-circle-bg-") ? url : avatarURL
          }
          alt="Avatar"
          loading="lazy"
        />
      )}
    </div>
  );
}

export default Avatar;
